import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/SubscriptionAdapter';
import {
  changeSubscriptionPricing,
  ChangeSubscriptionPricingActionType,
  subscriptionPricingChanged,
  subscriptionPricingChangeFailed,
} from '../../actions/subscription/changeSubscriptionPricing';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* changeSubscriptionPricingSaga({ payload }: ChangeSubscriptionPricingActionType) {
  const { id, feature, placeUuid, priceId } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.changeSubscriptionPricing, token, {
    id,
    priceId,
  });
  const timestamp = moment();
  const responsePayload = { timestamp, subscription: fromDto(response.subscription), placeUuid, feature };
  if (!response.error) {
    const responseAction = subscriptionPricingChanged(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = subscriptionPricingChangeFailed({ timestamp, id });
    yield put(responseAction);
  }
}

export default function* watchChangeSubscriptionPricingSaga() {
  yield takeEvery(changeSubscriptionPricing, changeSubscriptionPricingSaga);
}
